import { createFileRoute } from "@tanstack/react-router";
import { DataLineageOverview, type DataLineageSearch } from "@client/components/semantic-platform/lineage/data-lineage-overview";

function parseSearchNumber(value: unknown): number | undefined {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value !== "string" || value.trim() === "") return undefined;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

export const Route = createFileRoute("/_app/semantic-platform/data-lineage")({
  validateSearch: (search: Record<string, unknown>): DataLineageSearch => ({
    resourceType: typeof search.resourceType === "string" ? search.resourceType : undefined,
    resourceId: typeof search.resourceId === "string" ? search.resourceId : undefined,
    direction: typeof search.direction === "string" ? search.direction : undefined,
    depth: parseSearchNumber(search.depth),
    maxNodes: parseSearchNumber(search.maxNodes),
  }),
  component: DataLineagePage,
});

function DataLineagePage() {
  return <DataLineageOverview search={Route.useSearch()} />;
}
